<div class="meuMenu-guarda">
  <div class="meuMenu col-lg-12">
    <menu-app (clickMenu)="changeMenu($event)" [iconeLogo]="iconeLogo"></menu-app>
  </div>
</div>

<menu-internas-pagina
  (onRequestUser)="obterVisao($event)"
></menu-internas-pagina>

<div class="meuBode">
  <panel-menu
    [menu]="menuAberto"
    (menuChange)="changeMenu($event)"
    *ngIf="visao"
    [visao]="visao"
    class="sidenavy"
  ></panel-menu>

  <div class="container-principal">
    <router-outlet></router-outlet>
  </div>
</div>
